import React, { useEffect } from 'react';
import WOW from 'wowjs';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PersonIcon from '@mui/icons-material/Person';
// Ad Components
import VideoBannerAd from '../components/ads/VideoBannerAd';
import VideoBannerCarousel from '../components/ads/VideoBannerCarousel';
import GridAds from '../components/ads/GridAds';

const Contact = () => {
    useEffect(() => {
        const wow = new WOW.WOW({
            live: false
        });
        wow.init();
    }, []);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  const handleClose = () => {
      setAnchorEl(null);
    };
    // Carousel logic is now handled by VideoBannerCarousel component
    return (
<>
<>
  {/* <div id="page-preloader">
    <span className="spinner" />
  </div> */}
  {/* StickyHeaderAd is now in App.js - appears on all pages */}
  {/* ========================== */}
  {/* Navigation */}
  {/* ========================== */}
  <header className="header scrolling-header" style={{ position: 'relative', zIndex: 1000, marginTop: '30px' }}>
    <nav
      id="nav"
      className="navbar navbar-default"
      role="navigation"
    >
      <div className="container relative-nav-container">
        <a
          className="toggle-button visible-xs-block"
          data-toggle="collapse"
          data-target="#navbar-collapse"
        >
          <i className="fa fa-navicon" />
        </a>
        <a className="navbar-brand scroll" href="home.html" style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
          <img
            className="normal-logo hidden-xs"
            src={require("../img/logo.png")}
            alt="logo"
          />
          <img
            className="scroll-logo hidden-xs"
            src={require("../img/logo-dark.png")}
            alt="logo"
          />
          <img
            className="scroll-logo visible-xs-block"
            src={require("../img/logo.png")}
            alt="logo"
          />
        </a>
        {/* <ul class="nav navbar-nav navbar-right nav-icons wrap-user-control">
                  <li>
                      <a id="search-open" href="#fakelink"><i class="fa fa-search"></i></a>
                  </li>
                  <li class="open-signup">
                      <a href="#fakelink"><i class="fa fa-user"></i></a>
                  </li>
              </ul> */}
        <div className="navbar-collapse collapse floated" id="navbar-collapse">
          <ul className="nav navbar-nav navbar-with-inside clearfix navbar-right with-border">
            <li>
              <a href="#/home">home</a>
              {/* <div class=" wrap-inside-nav">
                              <div class="inside-col">
                                  <ul class="inside-nav">
                                      <li><a href="home.html">Home 1</a></li>
                                      <li><a href="home-2.html">Home 2</a></li>
                                  </ul>
                              </div>
                          </div> */}
            </li>
            {/* <li>
                          <a href="#">Portfolio</a>
                          <div class=" wrap-inside-nav">
                              <div class="inside-col">
                                  <ul class="inside-nav">
                                      <li><a href="portfolio.html">Portfolio</a></li>
                                      <li><a href="portfolio-2.html">Portfolio 2</a></li>
                                      <li><a href="portfolio-3.html">Portfolio 3</a></li>
                                      <li><a href="portfolio-single.html">Portfolio single 1</a></li>
                                      <li><a href="portfolio-single-2.html">Portfolio single 2</a></li>
                                  </ul>
                              </div>
                          </div>
                      </li> */}
            <li>
              <a href="#/about">about</a>
            </li>
            <li>
              <a href="#/services">services</a>
            </li>
            {/* <li>
              <a href="#/blog">Blog</a> */}
              {/* <div class=" wrap-inside-nav">
                              <div class="inside-col">
                                  <ul class="inside-nav">
                                      <li><a href="blog.html">Blog</a></li>
                                      <li><a href="blog-single.html">Blog single</a></li>
                                  </ul>
                              </div>
                          </div> */}
            {/* </li> */}
            <li className="active">
              <a href="#/contact">Contacts</a>
              {/* <div class=" wrap-inside-nav">
                              <div class="inside-col">
                                  <ul class="inside-nav">
                                      <li><a href="contact.html">Contacts 1 </a></li>
                                      <li><a href="contact-2.html">Contacts 2 </a></li>
                                  </ul>
                              </div>
                          </div> */}
            </li>
            <li><a href='#/login' target='_blank'> Login In</a></li>

          </ul>
        </div>
      </div>
      {/* <div class="navbar-search ">
              <div class="container">
                  <form>
                      <div class="input-group">
                          <input type="text" placeholder="Type your search..." class="form-control" autocomplete="off">
                          <span class="input-group-btn">
                              <button type="reset" class="btn search-close" id="search-close">
                                  <i class="fa fa-close"></i>
                              </button>
                          </span>
                      </div>
                  </form>
              </div>
          </div> */}
    </nav>
  </header>
  {/*./navigation */}
  {/* ========================== */}
  {/* CONTACT - HEADER */}
  {/* ========================== */}
  
  {/* <!-- ========================== -->
  {/* Video Banner Carousel Ad - Main banner with video */}
  {/* Position ID 2 - Same as Home page */}
  {/* ========================== */}
  <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
    <VideoBannerCarousel positionId={2} autoRotateInterval={3000} />
  </div>
  
  {/* <!-- ========================== -->
  {/* Grid Ads - 8 grid with 2 vertical items rotating every 10 seconds */}
  {/* Replace '3' with your actual position_id for grid ads */}
  {/* ========================== */}
  
  <section className="countact-us-section" style={{ paddingTop: '100px', paddingBottom: '100px', background: '#ffffff' }}>
    
    <div className="container">
      <div className="section-heading" style={{ marginBottom: '60px' }}>
        <div className="section-title" style={{ fontSize: '42px', fontWeight: '700', color: '#1a1a1a', marginBottom: '20px', textAlign: 'center', letterSpacing: '-0.5px' }}>
          Contact Us
        </div>
        <div className="section-subtitle" style={{ fontSize: '20px', color: '#666', textAlign: 'center', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
          Get in Touch - We're Here to Help You with All Your Real Estate Needs
        </div>
        <div className="design-arrow" style={{ marginTop: '30px' }}></div>
      </div>
      
      <div className="row">
        <div className="col-md-8">
          <div className="contact-form">
            <div className="form-heading" style={{ marginBottom: '20px' }}>
              <h3 style={{ fontSize: '28px', fontWeight: '700', color: '#1a1a1a', marginBottom: '10px' }}>Send a Message</h3>
            </div>
            <div className="form-description" style={{ marginBottom: '30px' }}>
              <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#666' }}>
                Have questions? Tell us about your requirements. Our experts will
                review everything and call you back to explain how Perfect Layout
                can help you with your property needs.
              </p>
            </div>
            <form
              method="post"
              action="sendEmail.php"
              name="contact-form"
              id="contact-form"
            >
              <div id="response" />
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      name="firstName"
                      id="firstName"
                      placeholder="First Name"
                      className="form-control"
                      style={{ 
                        padding: '15px 20px', 
                        fontSize: '16px', 
                        borderRadius: '8px', 
                        border: '1px solid #e0e0e0', 
                        transition: 'all 0.3s ease',
                        width: '100%',
                        marginBottom: '20px'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#ff6400';
                        e.target.style.boxShadow = '0 0 0 3px rgba(255, 100, 0, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e0e0e0';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      name="lastName"
                      id="lastName"
                      placeholder="Last Name"
                      className="form-control"
                      style={{ 
                        padding: '15px 20px', 
                        fontSize: '16px', 
                        borderRadius: '8px', 
                        border: '1px solid #e0e0e0', 
                        transition: 'all 0.3s ease',
                        width: '100%',
                        marginBottom: '20px'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#ff6400';
                        e.target.style.boxShadow = '0 0 0 3px rgba(255, 100, 0, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e0e0e0';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      name="phone"
                      id="phone"
                      placeholder="Phone Number"
                      className="form-control"
                      style={{ 
                        padding: '15px 20px', 
                        fontSize: '16px', 
                        borderRadius: '8px', 
                        border: '1px solid #e0e0e0', 
                        transition: 'all 0.3s ease',
                        width: '100%',
                        marginBottom: '20px'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#ff6400';
                        e.target.style.boxShadow = '0 0 0 3px rgba(255, 100, 0, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e0e0e0';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      name="subject"
                      id="subject"
                      placeholder="Subject"
                      className="form-control"
                      style={{ 
                        padding: '15px 20px', 
                        fontSize: '16px', 
                        borderRadius: '8px', 
                        border: '1px solid #e0e0e0', 
                        transition: 'all 0.3s ease',
                        width: '100%',
                        marginBottom: '20px'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#ff6400';
                        e.target.style.boxShadow = '0 0 0 3px rgba(255, 100, 0, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e0e0e0';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      name="message"
                      id="message"
                      placeholder="Your Message"
                      rows="6"
                      defaultValue={""}
                      style={{ 
                        padding: '15px 20px', 
                        fontSize: '16px', 
                        borderRadius: '8px', 
                        border: '1px solid #e0e0e0', 
                        transition: 'all 0.3s ease',
                        resize: 'vertical',
                        width: '100%',
                        minHeight: '150px',
                        marginBottom: '20px',
                        fontFamily: 'inherit'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#ff6400';
                        e.target.style.boxShadow = '0 0 0 3px rgba(255, 100, 0, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e0e0e0';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <button
                      type="submit"
                      id="submit"
                      className="btn btn-default"
                      style={{ 
                        padding: '15px 50px', 
                        fontSize: '17px', 
                        fontWeight: '600', 
                        borderRadius: '8px', 
                        background: 'linear-gradient(135deg, #ff6400 0%, #ff8533 100%)',
                        color: '#fff',
                        border: 'none',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 15px rgba(255, 100, 0, 0.3)',
                        textTransform: 'none',
                        letterSpacing: '0.5px'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 6px 20px rgba(255, 100, 0, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 4px 15px rgba(255, 100, 0, 0.3)';
                      }}
                    >
                      Send Message
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-md-4">
          <div className="row">
            <div className="col-md-12 col-sm-6">
              {/* <div class="contact-map" >
                              <div id="contactMap"></div>
                          </div> */}
            </div>
            <div className="col-md-12 col-sm-6">
              <div className="contact-block" style={{ background: '#f8f9fa', padding: '40px', borderRadius: '12px', boxShadow: '0 5px 20px rgba(0,0,0,0.08)' }}>
                <h5 style={{ fontSize: '24px', fontWeight: '700', color: '#1a1a1a', marginBottom: '30px' }}>Keep in Touch</h5>
                <div className="row ">
                  <div className="col-md-12 clearfix">
                    <div className="type-info pull-left">
                      <i className="icon icon-House" />
                      address
                    </div>
                    <div className="info pull-right text-right">
                      <p className="no-margin" style={{fontFamily:"sans-serif"+"important", textAlign:"left"}}>
                      NO. 2-1-266/1/6, Flat No.201, Plot NO. 6, 2nd Floor, GSI (Sr) Bandlanguda, Nagole, Hyderabad -500068
                      </p>
                    </div>
                  </div>
                  {/* <div className="col-md-12 clearfix">
                    <div className="type-info pull-left">
                      <i className="icon icon-Phone2" />
                      phone
                    </div>
                    <div className="info pull-right text-right">
                      <p className="no-margin">+91 8374416741</p>
                    </div>
                  </div> */}
                  <div className="col-md-12 clearfix">
                    <div className="type-info pull-left">
                      <i className="icon icon-Mail" />
                      email
                    </div>
                    <div className="info pull-right text-right">
                      <p className="no-margin">care@perfectlayout.in</p>
                    </div>
                  </div>
                  {/* <div class="col-md-12 clearfix">
                                      <div class="type-info pull-left">
                                          <i class="icon icon-Mouse"></i>
                                          Skype Chat
                                      </div>
                                      <div class="info pull-right text-right">
                                          <p class="no-margin">oscend.live</p>
                                      </div>
                                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <GridAds positionId={3} />

  {/* ========================== */}
  {/* FOOTER */}
  {/* ========================== */}
  <footer>
    {/* ========================== */}
    {/* BUY SECTION */}
    {/* ========================== */}
    {/* <section class="buy-section with-icon">
          <div class="section-icon"><span class="icon icon-Umbrella"></span></div>
          <div class="container">
              <div class="row">
                  <div class="col-md-8 col-md-offset-1 col-sm-9 wow fadeInLeft">
                      <div class="section-text">
                          <div class=" vcenter like">
                              <span class="icon icon-Like"></span> 
                          </div>
                          <div class="buy-text vcenter">
                              <div class="top-text">oscend - a creative & multipurpose template</div>
                              <div class="bottom-text">Lorem ipsum dolor sit amet consectetur elit sed</div>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-3 col-sm-3  wow fadeInRight">
                      <a href="#" class="btn btn-info ">Buy it now</a>
                  </div>
              </div>
          </div>
      </section> */}
    {/* ========================== */}
    {/* FOOTER - SOCIAL */}
    {/* ========================== */}
    {/* <section className="social-section dark dark-strong">
      <div className="container dark-content">
        <div className="tt">We are social 24/7 - Get in touch</div>
        <ul className="list-socials">
          <li>
            <a href="#">
              <i className="fa fa-twitter" />
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fa fa-facebook" />
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fa fa-linkedin" />
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fa fa-google-plus" />
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fa fa-dribbble" />
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fa fa-pinterest-p" />
            </a>
          </li>
        </ul>
      </div>
    </section> */}
    {/* ========================== */}
    {/* FOOTER - FOOTER */}
    {/* ========================== */}
    <section className="footer-section">
      <div className="container">
        <div className="row">
          {/* <div className="col-md-3 col-sm-3">
            <h5>about us</h5>
            <p>
              Crowned as ASIA’S GREATEST BRAND and ASIA’S GREATEST LEADER With
              Mr. Sathesh kumar Garu, the recipient of Global Indian Of The Year
              award, at the helm
            </p>
          </div> */}
          <div className="col-md-3 col-sm-3">
            <h5>Sitemap</h5>
            <div className="row">
              <div className="col-md-6">
                <ul className="footer-nav">
                  <li>
                    <a href="#">About Us</a>
                  </li>
                  <li className="active">
                    <a href="#">Latest News</a>
                  </li>
                  <li>
                    <a href="#">Contact us</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="footer-nav">
                  <li>
                    <a href="#">Get Help</a>
                  </li>
                  <li>
                    <a href="#">Careers</a>
                  </li>
                  <li>
                    <a href="#">FAQ's</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-3">
            <h5>Contact info</h5>
            <ul className="contacts-list">
              <li>
                <p>
                  <i className="icon icon-House" />
                  NO. 2-1-266/1/6, Flat No.201, Plot NO. 6, 2nd Floor, GSI (Sr) Bandlanguda, Nagole, Hyderabad -500068
                </p>
              </li>
              {/* <li>
                <p>
                  <i className="icon icon-Phone2" />
                  +91 8374416741
                </p>
              </li> */}
              <li>
                <p>
                  <i className="icon icon-Mail" />
                  <a href="mailto:support@oscend.com">
              care@perfectlayout.in
                  </a>{" "}
                </p>
              </li>
            </ul>
          </div>
          <div className="col-md-3 col-sm-3">
            <h5>newsletter</h5>
            <p>
              Subscribe to our newsletter for latest updates about our creative
              agency
            </p>
            <div className="form-group has-feedback">
              <input
                type="email"
                className="form-control "
                placeholder="Email address ..."
              />
              <i className="icon icon-Mail form-control-feedback" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="copyright-section">
      <p>
        ©2023 <span>PERFECT LAYOUT PRIVATE LIMITED </span>. All Rights Reserved
      </p>
    </section>
  </footer>
  
  {/* StickyPopupAd is now in App.js - appears on all pages */}
</>
</>)
}
export default Contact;